import { computeBytesCount } from './utils/byteUtils';
export function createIdentityEncoder() {
  var output = '';
  var outputBytesCount = 0;
  return {
    isAsync: false,

    get isEmpty() {
      return !output;
    },

    write: function write(data, callback) {
      var additionalEncodedBytesCount = computeBytesCount(data);
      outputBytesCount += additionalEncodedBytesCount;
      output += data;

      if (callback) {
        callback(additionalEncodedBytesCount);
      }
    },
    finish: function finish(callback) {
      callback(this.finishSync());
    },
    finishSync: function finishSync() {
      var result = {
        output: output,
        outputBytesCount: outputBytesCount,
        rawBytesCount: outputBytesCount,
        pendingData: ''
      };
      output = '';
      outputBytesCount = 0;
      return result;
    },
    estimateEncodedBytesCount: function estimateEncodedBytesCount(data) {
      return data.length;
    }
  };
}